(function ($) {
    let faqs = $('.c-faq__item');
    if (faqs) {
        faqs.each(function () {
            let faq = $(this);
            let header = $(this).find('.c-faq__header');
            let container = $(this).find('.c-faq__body');
            let content = $(this).find('.c-faq__content');
            header.on('click', function (event) {
                faq.toggleClass('c-faq__item--open');
                faq.addClass('c-faq__item--collapsing');
                if (faq.hasClass('c-faq__item--open')) {
                    container.css({height: content[0].scrollHeight});
                }
                setTimeout(function () {
                    container.css({height: ''});
                    faq.removeClass('c-faq__item--collapsing');
                }, 400);
            });
        });
    }
})(jQuery);
